"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeLayoutSectionHeaderHandler = void 0;
var tslib_1 = require("tslib");
var general_1 = require("../../events/general");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var effects_1 = require("redux-saga/effects");
var layoutValidation_1 = require("./validation/layoutValidation");
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var layout_1 = require("../../store/layout");
var layout_2 = require("../../events/layout");
var utils_1 = require("./utils");
function changeLayoutSectionHeaderHandler(ctx, cmd) {
    var layout, _a, index, header, mergeHeaders, existingHeader, newHeader, sanitizedHeader;
    var _b;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectLayout)];
            case 1:
                layout = _c.sent();
                _a = cmd.payload, index = _a.index, header = _a.header, mergeHeaders = _a.merge;
                if (!layoutValidation_1.validateSectionExists(layout, index)) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Attempting to modify header of non-existent section at " + index + ". There are currently " + layout.sections.length + " sections.");
                }
                existingHeader = (_b = layout.sections[index].header) !== null && _b !== void 0 ? _b : {};
                newHeader = mergeHeaders ? merge_1.default({}, existingHeader, header) : header;
                sanitizedHeader = utils_1.sanitizeHeader(newHeader);
                return [4 /*yield*/, effects_1.put(layout_1.layoutActions.changeSectionHeader({
                        index: index,
                        header: sanitizedHeader,
                        undo: {
                            cmd: cmd,
                        },
                    }))];
            case 2:
                _c.sent();
                return [2 /*return*/, layout_2.layoutSectionHeaderChanged(ctx, sanitizedHeader, index, cmd.correlationId)];
        }
    });
}
exports.changeLayoutSectionHeaderHandler = changeLayoutSectionHeaderHandler;
//# sourceMappingURL=changeLayoutSectionHeaderHandler.js.map